<template>
  <div class=priprotocol>
    <mt-header title="隐私保护协议">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
    </mt-header>
    <div class="wrap">
	<div>
		本《隐私保护协议》属于《用户注册和使用协议》的有效组成部分，本网站有权根据实际情况的变化和需要以及用户的建议对本《隐私保护协议》进行修订与更新，修订与更新的内容于公布的生效日期生效。
	</div>
	<div>
		<span class="bold">本隐私保护协议构成本网站对用户隐私保护的承诺</span>。完成注册即意味着用户接受《用户注册和使用协议》和《隐私保护协议》全部内容。
	</div>
	<div class="h1">
		一、受保护信息
	</div>
	<div>
		1.用户向本网站提交的用于注册和使用相关服务的信息、本网站在实名认证或提供服务的过程中时获取的相关信息均属于受保护范围。
	</div>
	<div>
		2.用户应确保提供给本网站的信息的真实性、完整性以及信息更新的及时性，本网站对任何涉及虚假、欺诈的不合法或不符合本网站规则的信息不必然提供保护。
	</div>
	<div>
		3.用户发现其信息已经被泄露或者存在被泄露的可能，且可能会危及到用户在本网站注册账户的安全，或者可能给用户造成其他的损失的，应在第一时间通知本网站，以便本网站采取相应的措施防止损失的发生或者进一步扩大。
	</div>
	<div class="h1">
		二、信息采集授权
	</div>
	<div>
		用户在使用本网站的服务时，为了更好服务用户、提高服务品质，本网站有权收集用户的相关信息（以下统称“用户信息”）包括但不限于：
	</div>
	<div>
		1.个人、企业、其他组织的相关信息，包括身份证信息、企业证照的相关信息、银行信息、联系电话、联系地址、实际住所等；
	</div>
	<div>
		2.用户在使用本网站服务过程中提交的、形成的数据信息；
	</div>
	<div>
		3.用户提供给第三方或者向第三方披露的且与用户在本网站注册或使用服务相关的信息及隐私；
	</div>
	<div>
		4.用户登录和使用本网站或子网站的网页、App、小程序、移动网页的时间、时长、支付信息、银行账户信息以及服务使用痕迹和记录；
	</div>
	<div>
		5.用户使用的计算机、移动设备的品牌、型号、IP地址以及软件版本等信息；
	</div>
	<div>
		6.为了实现前述目的，通过cookie或者其他方式自动采集到的其他信息或者隐私；
	</div>
	<div>
		7.用户通过具有定位功能的移动设备登录、使用本网站的App或移动网页时，本网站有权通过GPS或者Wifi收集用户的地理位置信息；如果不同意收集地理位置信息，应关闭移动设备上的此项功能（但，关闭此项功能有可能导致部分服务无法使用）。
	</div>
	<div class="h1">
		三、信息披露授权
	</div>
	<div>
		本网站不向任何无关第三方透漏用户信息，但存在下列任何一项情形或者为下述第四条合理使用目的而披露给第三方的除外：
	</div>
	<div>
		1.基于国家法律法规的规定而对外披露；
	</div>
	<div>
		2.应国家司法机关及其他有权机关基于法定程序的要求而披露；
	</div>
	<div>
		3.为保护本网站或用户的合法权益而披露；
	</div>
	<div>
		4.在紧急情况下，为保护其他用户或者第三方人身安全而披露；
	</div>
	<div>
		5.用户本人或其监护人授权披露；
	</div>
	<div>
		6.应用户的监护人的合法要求而向其披露。
	</div>
	<div>
		本网站按照前款约定进行用户信息披露时，将要求数据信息接收方在国家法律法规规定和委托合同约定的范围内使用并保护用户信息。
	</div>
	<div class="h1">
		四、信息合理使用授权
	</div>
	<div>
		本网站有权将用户提交的和本网站采集到的信息用于包括但不限于下列某一个或者某几个目的，且此目的可以由本网站达成也可以由本网站委托的第三方达成（但第三方行为将受限于本网站与其签署的委托合同，并遵守相关规定）：
	</div>
	<div>
		1.用户登录本网站的网页或者子网站、独立运营的网站、APP、小程序时，用于验证用户的身份、供用户支付费用、为用户提供本网站的相关服务；
	</div>
	<div>
		2.帮助本网站分析、了解用户需求，设计新的商业模式和新产品，向用户及他人推荐新的产品和服务，或者用于本网站开展的新业务；
	</div>
	<div>
		3.评估和改进本网站服务中的产品、服务和其他推广活动效果；
	</div>
	<div>
		4.本网站、子网站、独立运营的网站、APP、小程序的的升级、改版；
	</div>
	<div>
		5.其他的用于改进本网站的服务、提升用户体验的目的。
	</div>
	<div>
		本网站或者接收了本网站委托的第三方企业或者公司发生合并或者分立，那么合并或者分立后企业或者公司仍然有权按照本《隐私保护协议》及其他相关约定采集、披露并保护相关信息，而无须另行征得用户的同意。
	</div>
	<div class="h1">
		五、多网站账户通用（免注册）授权
	</div>
	<div>
		1.本网站为更好提供相关服务、提升客户体验，有权为不同类型的服务在本网站架构下设立子网站、独立运营的网站、APP、小程序，该子网站、独立运营的网站、APP、小程序可以由本网站作为入口接入服务。
	</div>
	<div>
		2.多网站账户通用（免注册）授权指：为保证用户获得连续的服务、减少用户的注册程序，用户一经在本网站或子网站、独立运营的网站、APP、小程序注册，即成为前述全部网站的注册用户，用户如需使用前述任何网站的相关服务无需另行注册只需开通服务即可。
	</div>
	<div>
		3.多网站账户通用（免注册）授权为用户对前述全部网站、APP、小程序的运营方北京联合信任技术服务有限公司的不可撤销的授权，是完成本网站注册和使用本网站服务的必要前提。
	</div>
	<div>
		4.为保护用户的权利，本网站将前述全部子网站或独立运营的网站明示如下：
		<div><span class="bold">●</span> www.tsa.cn</div>
        <div><span class="bold">●</span> www.1sign.cn </div>
        <div><span class="bold">●</span> 权利卫士手机APP</div>
	</div>
	<div class="h1">
		六、信息保护措施
	</div>
	<div>
		1.用户应妥善保管自己的账户密码等账户信息，不得向其他任何人泄露用户的用户名、密码及可以用于密码找回、完成登录等操作的信息，亦不可使用其他任何人的用户名和密码。因用户的保管疏忽等非本网站原因导致账号遭他人非法使用的，本网站不承担任何责任。
	</div>
	<div>
		2.冒用他人账号使用本网站服务、冒用他人信息在本网站注册，本网站有权配合实际权利人或承受损失的一方维护自身权利。
	</div>
	<div>
		3.本网站将会使用各种安全技术和手段保护用户账户及账户内的数据信息，防止其被未经授权的访问、使用、复制和泄露。但用户应该知道并接受“受限于网络技术的发展，不存在绝对安全的保障措施，也无法完全避免信息泄露的风险”，因此非本网站原因导致信息泄露和其他损失，本网站不承担任何责任。
	</div>
	<div class="h1">
		七、保密条款
	</div>
	<div>
		本网站及用户均需严格遵守保密条款，保护双方商业秘密及相关权益。包括但不限于产品知识产权、策划方案、客户资料、协议合同、技术文档、程序文件、程序控件或源代码、各种账户密码。任何人不得泄漏对方的任何商业秘密，同时不得利用工作之便获取对方技术秘密。对于双方授权使用的技术，只能使用于授权时指定的范围，不得用于它途。
	</div>
	<div class="h1">
		八、第三方网站
	</div>
	<div>
		本网站含有访问第三方网站的链接，且有权在任何时候增加或减少合作第三方的网站链接。所有第三方网站的隐私保护措施均独立于本网站存在，对此本网站不承担任何责任。
	</div>
	<div class="h1">
		九、赔偿限制
	</div>
	<div>
		违反本《隐私保护协议》或者本《隐私保护协议》部分条款无效，导致本网站不得不向用户进行赔偿的，那么赔偿的最高金额遵守《用户注册与使用协议》的相关约定，即本公司对所承担的违约赔偿责任总额不超过向用户收取的当次服务费用总额。
	</div>
	<div class="h1">
		十、其他
	</div>
	<div>
		1.本《隐私保护协议》是《用户注册与使用协议》不可分割的组成部分，具有同等的法律效力；本《隐私保护协议》与《用户注册与使用协议》不一致或者矛盾的地方，适用本《隐私保护协议》；未涉及的内容，仍适用《用户注册与使用协议》。
	</div>
	<div>
		2.本《隐私保护协议》所约定的任何条款如果部分或者全部无效，不影响该条款其他部分及本协议其他条款的法律效力。
	</div>

</div>
  </div>
</template>

<script>
  import cheader from '@/components/header';
  export default {
    data () {
      return {
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      }
    }
  }
</script>
<style>
.wrap{width:100%; max-width: 1200px; margin: 0 auto; padding: 25px 20px; line-height: 30px; box-sizing: border-box;}
		.bold{font-weight: bold;}
		.title{font-size:24px; color:#000; text-align: center; margin-bottom: 30px;}
		.h1{font-weight: bold; color:#000; font-size: 18px;}
		.h2{font-weight: bold; color:#000; font-size: 16px;}
		.red{color:red;}
		.h3{padding-left:2em}
		.border{border:1px solid #000}
		@media screen and (min-width:320px) and (max-width:420px) {
		    .wrap {
		        line-height: 30px;
		    }
		    .title{
		    	margin-bottom: 20px;
		    }
		}
</style>



// WEBPACK FOOTER //
// src/module/register/PriProtocol.vue